import {useState, useEffect} from "preact/compat";
import {api} from "../../../../services";

export const useStoreInfoModal = (props) => {
    // Destructured props
    const {
        externalId,
        isOpen
    } = props;

    // Stores all the data from the store
    const [storeData, setStoreData] = useState({});
    // State to control the fetch operation load state
    const [isLoading, setIsLoading] = useState(false);

    // Procedure to fetch the store data
    const fetchStoreData = async () => {
        setIsLoading(true);

        try {
            // The actual api call
            let response = await api.get(`/v1/cms/unit?id=${externalId}`);

            setStoreData(response.data);
        } catch (e) {
            console.error("Error while fetching store data:", e);
        } finally {
            setIsLoading(false);
        }
    }

    // Effect to trigger the fetch operation
    useEffect(() => {
        // Prevents unnecessary code execution
        if (
            !externalId ||
            (
                Object.keys(storeData).length < 1 &&
                !isOpen
            )
        ) {
            return;
        }

        // Clears the store data object when the modal is closed
        if (
            Object.keys(storeData).length > 0 &&
            !isOpen
        ) {
            const timer = setTimeout(() => {
                setStoreData({});

                clearTimeout(timer);
            }, 300);

            return;
        }

        // Dispatches the fetch operation
        fetchStoreData().then();
    }, [
        externalId,
        isOpen
    ]);

    return {
        storeData,
        isLoading
    }
}
